export default __webpack_public_path__ + "static/media/marker.4f827b95.svg";